import type React from 'react';
import type {
  BasicContentBlockB,
  BasicContentLayout,
} from '@course-authoring/shared-types';

import { BasicContentBlockEditor } from './BasicContentBlockEditor';

export interface BasicContentBlockBEditorProps {
  block: BasicContentBlockB;
  onChange: (updates: Partial<BasicContentBlockB>) => void;
  onSetLayout: (layout: BasicContentLayout) => void;
  autoFocus?: boolean;
  translationMode?: boolean;
}

export function BasicContentBlockBEditor({
  block,
  onChange,
  onSetLayout,
  autoFocus = false,
  translationMode = false,
}: BasicContentBlockBEditorProps): React.ReactElement {
  return (
    <BasicContentBlockEditor
      block={block}
      onChange={(updates) => onChange(updates as Partial<BasicContentBlockB>)}
      onSetLayout={onSetLayout}
      autoFocus={autoFocus}
      translationMode={translationMode}
    />
  );
}

BasicContentBlockBEditor.displayName = 'BasicContentBlockBEditor';
